import Layout from '../layout/Layout';
import Carousel from 'react-bootstrap/Carousel';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import { useCloudinaryFolder } from '../hooks/useCloudinaryImages';

export default function Home() {
  const { images: slides, loading, error } = useCloudinaryFolder('carousel');

  return (
    <Layout>
      {error ? <Alert variant="danger">{error}</Alert> : null}

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      ) : slides.length > 0 ? (
        <Carousel variant="dark" indicators={false} fade interval={2000}>
          {slides.map((slide) => (
            <Carousel.Item key={slide.id}>
              <img className="d-block mx-auto" src={slide.url} alt="slide" />
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <div className="text-center py-5 text-muted">
          No hay imagenes cargadas para el carrusel.
        </div>
      )}
    </Layout>
  );
}
